export default "__VITE_PUBLIC_ASSET__4dca5f96__"